import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";
import { formatFileSize } from "./fileMeta";

/**
 * Read-only FILE size field: renders the raw byte count as a human-readable
 * binary size (KiB / MiB / GiB). The exact byte count is surfaced through the
 * Input hover tooltip, configured as `fieldAttr.fieldTooltip` in the file
 * resource config (see config/resources/file.tsx).
 * (operator-task-fe-file-screen-humanreadable-size-and-content-type)
 */
export const FileSizeFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => (
    <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
        {formatFileSize(input.value)}
    </Input>
);
